module.exports = __webpack_public_path__ + "media/images/default_beer_image-45dec7558237832a200f0df917cc5a4f.svg";